module.exports = __webpack_public_path__ + "img/bg-app-list-banner.a096a8e5.png";